// src/components/ApiService.js
import { toast } from "react-toastify";

export const ApiService = {
	/**
	 *
	 * @param {string} url
	 * @param {object} options
	 * @param {boolean} decision
	 * @returns {Promise<null|any>} -
	 */
	async fetchData(url, options = {}, decision = true) {
		try {
			const token = localStorage.getItem("token");
			const API_URL = process.env.REACT_APP_API_URL;

			// Agregar encabezados, incluyendo el token si existe
			const headers = {
				...(token ? { Authorization: `Bearer ${token}` } : {}),
				...options.headers,
			};

			// Solo si 'decision' es true, agregamos Content-Type JSON
			if (decision === true) {
				headers["Content-Type"] = "application/json";
			}

			const response = await fetch(`${API_URL}${url}`, {
				...options,
				headers,
			});

			if (response.status === 401) {
				localStorage.clear();
			  
				// Evita redireccionar si ya estás en /login
				if (window.location.pathname !== "/login") {
				  window.location.href = "/login";
				}
			  
				// throw new Error("Credenciales incorrectas");
			  }
			  

			if (response.status === 403) {
				const data403 = await response.json().catch(() => null);

				if (data403?.message === "Verificar") {
					return data403; //
				} else {
					toast.error(data403?.message || "Error de permisos", { position: "top-right" });
					//return null;
					throw new Error(data403?.message || "Error de permisos");
				}
			}
			if (response.status === 500) {
				// Intentar obtener el mensaje del error si existe
				let errorMessage = "Error interno del servidor.";

				try {
					const errorData = await response.json();
					if (errorData && errorData.message) {
						errorMessage = errorData.message; // Asignamos el mensaje si existe
					}
				} catch (error) {}

				// Mostrar el error solo si hay un mensaje

				toast.error(errorMessage, { position: "top-right" });
				throw new Error(errorMessage);
			}

			if (!response.ok) {
				// Intentar parsear el error devuelto
				const errorData = await response.json().catch(() => null);
				const errorMessage = errorData?.message || "Error en la solicitud";
				throw new Error(errorMessage);
			}

			if (response.ok) {
				let data;
				try {
					data = await response.json();
				} catch (error) {
					data = {};
				}
				return data; // Retornamos lo parseado o {}
			}
		} catch (error) {
			const get_message = error.message ?? "Error en la solicitud";
			toast.error(get_message);
			return null;
		}
	},

	/**
	 * @param {string} url
	 * @returns {Promise<Blob|null>}
	 */
	async fetchImage(url) {
		try {
			const token = localStorage.getItem("token");
			const API_URL = process.env.REACT_APP_API_URL;

			// Verifica si la URL ya contiene API_URL
			const fullUrl = url.startsWith(API_URL) ? url : `${API_URL}${url}`;

			// Incluimos el Bearer si lo necesitas para autenticar la descarga
			const headers = {
				...(token ? { Authorization: `Bearer ${token}` } : {}),
			};

			const response = await fetch(fullUrl, {
				method: "GET",
				headers,
			});

			// Manejo de errores de autenticación
			if (response.status === 401) {
				localStorage.clear();
				window.location.href = "/login";
				return null;
			}

			if (!response.ok) {
				const errorText = await response.text().catch(() => "");
				throw new Error("Error al descargar la imagen: " + errorText);
			}

			const blob = await response.blob();
			return blob;
		} catch (error) {
			console.error("Error al descargar la imagen:", error);
			return null;
		}
	},
};
